<ng-content></ng-content>

<zef-fade-animation
  [animationState]="active()"
  [animationParams]="{
    enterDuration: '700ms',
    leaveDuration: '700ms',
    easing: 'ease-out'
  }">
  @if (active()) {
    <mat-progress-bar
      class="__progress"
      mode="buffer">
    </mat-progress-bar>
  }
</zef-fade-animation>
